import React, { useEffect, useState, useRef } from 'react';
import './businessInfo.scss';
import { Card, Form, Input, Button, Row, Col, Alert, Modal, Spin } from 'antd';
import LogoIcon from '../../../../src/assets/images/logo_icon.png';
import ImageCropper from '../../Components/ImageCropper/ImageCropper';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { businessInfo } from '../../../slices/businessInfo/thunk';
import { api } from '../../../helpers/api_helper';
import _ from 'lodash';
import { getVerifiedStatus } from '../../../Services/LocalStorageService';
import NoResults from '../../Components/NoResults/NoResults';
import AsyncSelect from '../../Components/AsyncSelect/AsyncSelect';
import Link from 'antd/es/typography/Link';
// import bottomArrow from '../../../assets/images/bottom_arrow_grey.svg'
import { fetchData } from '../../../Services/FetchData';
import { API_ENDPOINTS } from '../../../constants/apiEndPoints';
import bottomArrow from '../../../assets/images/bottom_arrow_dark.svg'
import { getDashboard } from '../../../slices/dashboard/thunk';
import { DirectionContentService } from '../../../Services/DirectionContentService';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import RejectedUi from '../RejectedUi/RejectedUi';
import reviewIcon from '../../../assets/images/review_icon.svg';
import { VerificationStatusClassUpdate } from '../../../Services/AdsStatusService';
import Warning from '../../../Common/Warning/Warning';
import BillingAddress from '../../Components/BillingAddress/BillingAddress';
import { formatInputValue } from '../../../Services/InputFieldService';
import { validationContent } from '../../../constants/Validation';
import { Popup_Toast } from '../../../constants/Popups_Toast';
import { PlaceholderContent } from '../../../constants/Placeholder';
import useBillingAddressModalWithFormStates from '../../../Common/Hooks/useBillingAddressModalWithFormState'
import Avatar from '../../Components/Avatar/Avatar';
import InputFieldMxLength from '../../../Common/iInputFieldLength/InputFieldLength';

const { TextArea } = Input;

let content = validationContent?.BUSINESS_INFO_PAGE;
let popupContent = Popup_Toast?.BUSINESS_INFO_SAVED;
let placeHolderContent = PlaceholderContent?.BUSINESS_INFO_PAGE;

const isValidBase64 = (str) => {
    if (str && !str.startsWith("https:")) {
        return true;
    }
    return false;
};

const BusinessInfo = () => {
    let adminVerificationStatus = useSelector((state) => state.Dashboard?.adminVerificationStatus);
    document.title = "Business Info";
    const [businessInfoData, setBusinessInfoData] = useState({
        business_name: '',
        business_category: '',
        business_description: '',
        business_address: '',
        billing_address: '',
        contact_person: '',
        gst_in: '',
        pan_no: '',
        contact_number: '',
        instagram: '',
        facebook: '',
        whatsapp: '',
        website: '',
        location: '',
        pincode: '',
        state: {
            label: "Kerala",
            code: "KL"
        }
    })
    const [businessInfoApiResponseData, setBusinessInfoApiResponseData] = useState({});
    const [popupLocationData, setPopupLocationData] = useState();
    const [updatedLocationData, setUpdatedLocationData] = useState();
    const [businessInfoBtnDisable, setBusinessInfoBtnDisable] = useState()
    const [successModal, setSuccessMOdal] = useState(false);
    const [handleCancel, setHandleCancel] = useState(false);
    const [logoUrl, setLogoUrl] = useState('');
    const [visible, setVisible] = useState(true);
    const [logoError, setLogoError] = useState(false);
    const dispatch = useDispatch();
    const formRef = useRef(null);
    let submitButtonRef = useRef(null);
    let formHolderRef = useRef(null);
    const [previewRemove, setPreviewRemove] = useState(false);
    const [status, setStatus] = useState(getVerifiedStatus)
    const [locationError, setLocationError] = useState(false);
    // const initiatePaymentStatus = location.state?.initiatePaymentStatus;
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [BusinessInfo] = Form.useForm();
    const [businessAddressPresent, setBusinessAddressPresent] = useState(false);
    const [billingAddressModalReset, setBillingAddressModalReset] = useState(false);
    const [billingAddressModalHandle, SetBillingAddressModalHandle] = useState(false);
    const [businessInfoButtonDisable, setBusinessInfoButtonDisable] = useState({
        'dataUpdateError': false,
        'formError': true
    })
    const [warning, setWarning] = useState({
        "title": '',
        "content": ''
    })
    const [fieldStatus, setFieldStatus] = useState({
        'business_name': false,
        'business_description': false,
        'contact_name': false
    })

    // 

    const [limit, setLimit] = useState({
        'business_name': 150,
        'business_description': 500,
        'business_address': 200,
        'contact_person': 150,
    })

    const [fieldLengths, setFieldLengths] = useState({
        businessDescription: 0,
        businessName: 0,
        businessAddress: 0,
        contactPerson: 0,

    });


    // Create a ref for the form
    const [imageCropperError, setImageCropperError] = useState();
    const [actionModal, setActionModal] = useState({
        direction: false
    })
    const errors = BusinessInfo.getFieldsError();
    const hasErrors = errors.some(field => field.errors.length > 0);
    const [actionModalValue, setActionModalValue] = useState({
        direction: '',
    })
    const [prefilledActionValue, setPrefilledActionValue] = useState({
        direction: false,
    })
    let directionContent = DirectionContentService.content;
    const validateGoogleMapsUrl = (event) => {
        const value = event.target.value;

        // Define the regex pattern for valid Google Maps URLs
        const urlPattern = /^(https?:\/\/)?(www\.)?(google\.com\/maps\/|maps\.google\.com\/|maps\.app\.goo\.gl\/|goo\.gl\/maps\/)[\w\-]+/;

        // Determine if the URL is valid
        const isValidUrl = value && urlPattern.test(value);

        // Update the state for action button based on URL validity
        setActionButtonDisable((prevState) => ({
            ...prevState,
            direction: !isValidUrl,  // Disable the button if the URL is invalid
        }));

        return Promise.resolve();
    };
    const [actionModalData, setActionModalData] = useState({
        'direction': {
            'value': 'direction',
            'title': 'Add Location Link from Google Maps',
            'label': 'Location',
            'content': directionContent,
            'placeholder': 'https://www.google.com/maps/place/Your+Business+Location+Here',
            'validator': validateGoogleMapsUrl,
            'maxLength': 150
        },
    })
    const handleActionModalCancel = () => {
        setPopupLocationData(updatedLocationData)
        setActionModal((prev) => ({
            ...prev,
            direction: false,
        }));
    };
    const handleActionChange = (e) => {
        setActionModalValue((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    let modalContinue = (val) => {
        handleActionModalCancel()
        updateBusinessInfo({ location: popupLocationData }, false);
    }

    const handleCancelFn = (() => {
        setSuccessMOdal(false);
        setHandleCancel(false);
        setBillingAddressFormSubmitButtonStatus(false)

        console.log('modal cancel clicked ')


    })
    const data = (value, logosrc) => {
        setVisible(value);
        // let logoImg = JSON.stringify(logosrc);
        setLogoUrl(logosrc);
        setLogoError(false);
        setPreviewRemove(true)
        setBusinessInfoButtonDisable((prev) => (
            {
                'dataUpdateError': false,
                'formError': false
            }
        ))
    };

    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true)
        try {
            dispatch(businessInfo())
        }
        finally {
            setLoading(false)
        }
    }, [pathname]);

    let businessInfoDetails = useSelector(state => state.BusinessInfoReducer);
    businessInfoDetails = businessInfoDetails.businessInfo;

    useEffect(() => {

        if (businessInfoDetails?.isProfileApprovedByAdmin) {
            let statusClass = VerificationStatusClassUpdate(businessInfoDetails?.isProfileApprovedByAdmin)

            let data = businessInfoDetails?.warning;
            setWarning(
                {
                    title: data?.title,
                    content: data?.description,
                    warningStatus: statusClass,
                    rawStatus: businessInfoDetails?.isProfileApprovedByAdmin
                }
            )
        }
    }, [businessInfoDetails])

    let businessInfoDataFlag = true;
    const [billingAddressModal, setBillingAddressModal] = useState(false)

    useEffect(() => {

        setFieldStatus({
            'business_name': businessInfoDetails?.old_business_name ? businessInfoDetails?.old_business_name === businessInfoDetails?.business_name : false,
            'business_description': businessInfoDetails?.old_business_description === businessInfoDetails?.business_description,
            'contact_name': businessInfoDetails?.old_contact_name === businessInfoDetails?.contact_name,
        })

        if (businessInfoDetails.old_business_logo) {
            setLogoUrl(businessInfoDetails.old_business_logo?.original ? businessInfoDetails.old_business_logo?.original : businessInfoDetails.business_logo?.original);
            setVisible(false);
            if (businessInfoDetails?.gst_in) {
                setGstVerified(true)
            }
        }
        setBusinessInfoData({
            business_name: businessInfoDetails.old_business_name ? businessInfoDetails.old_business_name : businessInfoDetails.business_name,
            business_category: businessInfoDetails.business_category,
            business_description: businessInfoDetails.old_business_description !== 'undefined' ? businessInfoDetails.old_business_description : businessInfoDetails.business_description,
            business_address: businessInfoDetails.old_business_address ? businessInfoDetails.old_business_address : businessInfoDetails.business_address,
            billing_address: businessInfoDetails?.billing_address?.address,
            contact_name: businessInfoDetails.old_contact_name ? businessInfoDetails.old_contact_name : businessInfoDetails.contact_name,
            contact_number: businessInfoDetails.contact_number,
            instagram: businessInfoDetails?.instagram,
            facebook: businessInfoDetails?.facebook,
            whatsapp: businessInfoDetails.contact_number,
            website: businessInfoDetails.website || '',
            location: businessInfoDetails?.location,
            gst_in: businessInfoDetails?.gst_in,
            pan_no: businessInfoDetails?.pan_no,
            pincode: businessInfoDetails?.pincode,
            state: businessInfoDetails?.state?.label
        });


        if (businessInfoDataFlag) {
            businessInfoDataFlag = false;
            setBusinessInfoApiResponseData(businessInfoData)
        }


        if (businessInfoDetails.billing_address) {
            setBusinessAddressPresent(true)
        }
    }, [businessInfoDetails]);

    const onFinish = (values) => {
        if (!logoUrl) {
            setLogoError(true);
        }

        const formData = {
            ...values,
        };

        if (isValidBase64(logoUrl)) {
            formData['file'] = logoUrl.replace(/^[\\\"\']+|[\\\"\']+$/g, '');
        }
        const {
            billing_address,
            state = { label: "Kerala", code: "KL" }, // Default state if undefined
            ...businessDetails
        } = formData;

        // Add the state back to the businessDetails object
        businessDetails.state = {
            label: state.label || "Kerala",
            code: state.code || "KL",
        };



        setLoading(true);

        api.create(`${API_ENDPOINTS.BUSINESS_INFO.UPDATE}`, businessDetails)
            .then((response) => {
                setSuccessMOdal(response.message);
                dispatch(businessInfo());

            })
            .catch((error) => {
                alert(error);
            })
            .finally(() => {
                setLoading(false);
                setBusinessInfoButtonDisable((prev) => ({
                    ...prev, 'formError': true
                }))
            });
    };



    const validateMessages = {
        required: '${label} is required!',
        types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!',
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        },
    };


    // billing address new change 
    const [billingAddressPresent, setBillingAddressPresent] = useState(false)
    const [billingAddressPopup, setBillingAddressPopup] = useState(false);
    const [billingAddressCompleted, setBillingAddressCompleted] = useState(false)
    let billingAddressFlag = false;
    const [stateList, setStateList] = useState([]);
    const [activeState, setActiveState] = useState();
    const [gstVerified, setGstVerified] = useState(false)
    const [isCustomDropdownVisible, setCustomDropdownVisible] = useState(false);
    const [billing_address, setBillingAddress] = useState({
        name: '',
        country: {
            code: "IN",
            label: "India"
        },
        address: '',
        phone: '',
        area: '',
        landmark: '',
        city: {
            label: ''
        },
        state: {
            code: "",
            label: ""
        },
        pincode: ''
    });
    const [scrollTop, setScrollTop] = useState(0);
    const [submitButtonPositionTop, setSubmitButtonPositionTop] = useState(0);
    const [submitBtnFixed, setSubmitBtnFixed] = useState(false);
    useEffect(() => {
        dispatch(getDashboard());
        const fetchDataAsync = async () => {
            try {
                const endPoint = API_ENDPOINTS.GET_STATE;
                const fetchedData = await fetchData(endPoint);
                if (fetchedData) {
                    setStateList(fetchedData);
                }
            } catch (error) {
                console.error('Error fetching state data:', error);  // More descriptive error message
            }
        };

        fetchDataAsync();
    }, [])
    const [actionButtonDisable, setActionButtonDisable] = useState({
        direction: true,
    })
    useEffect(() => {
        setBillingAddress((prev) => (
            {
                ...prev, state: {
                    code: activeState?.code,
                    label: activeState?.label
                }
            }
        ))
    }, [activeState])
    const [billingAddressFormSubmitButtonStatus, setBillingAddressFormSubmitButtonStatus] = useState(false);

    let billingData;
    let businessAddress;
    let name;
    useEffect(() => {



        // checking the billing address
        if (businessInfoDetails) {
            billingData = businessInfoDetails?.billing_address;
            let contactNumber = businessInfoDetails?.contact_number;
            let state = businessInfoDetails?.billing_address?.state;
            businessAddress = businessInfoDetails?.business_address;
            name = businessInfoDetails?.contact_name;
            if (!billingData) {
                setBillingAddressPresent(false)
            }
            else {
                setBillingAddressPresent(true)
            }
            // prefilled billing address when the user closes the popup
            setBillingAddress(
                {
                    name: billingData?.name || name,
                    country: {
                        label: billingData?.country?.label,
                        code: billingData?.country?.code
                    },
                    address: billingData?.address || businessAddress || '',
                    phone: contactNumber,
                    area: billingData?.area || '',
                    landmark: billingData?.landmark || '',
                    city: {
                        label: billingData?.city?.label || ''
                    },
                    state: {
                        code: billingData?.state?.code || '',
                        label: billingData?.state?.label || ''
                    },
                    pincode: billingData?.pincode || ''
                }
            )

            setActiveState(state)
        }


    }, [businessInfoDetails])


    useEffect(() => {
        const isValid =
            billing_address?.name &&
            billing_address?.country && billing_address?.country?.label && billing_address?.country?.code &&
            billing_address?.address &&
            billing_address?.phone &&
            billing_address?.city && billing_address?.city?.label &&
            billing_address?.state && billing_address?.state?.label && billing_address?.state?.code &&
            billing_address?.pincode && billing_address?.pincode.length === 6;

        setBillingAddressFormSubmitButtonStatus(!isValid);


    }, [billing_address]);

    const [businessAddressForm] = Form.useForm();
    const businessAddressInitialValues = {
        name: billing_address?.name,
        country: billing_address?.country?.label || 'India',
        address: billing_address?.address,
        phone: billing_address?.phone,
        area: billing_address?.area || '',
        landmark: billing_address?.landmark || '',
        city: billing_address?.city?.label || '',
        state: billing_address?.state?.label || 'Kerala',
        pincode: billing_address?.pincode || ''
    };
    const [locationUpdate, setLocationUpdate] = useState(false);

    const handleBusinessAddressChange = (event) => {
        const { name, value } = event.target;
        setBillingAddress((prev) => {
            return { ...prev, [event?.name]: value }
        })
    }



    const billingAddressModalSubmit = () => {
        try {
            setLoading(true);
            updateBusinessInfo({
                billing_address
            })
            setLoading(true);
            // setBillingAddressPopup(false)
        }
        catch (error) {
            setLoading(false);
            console.log('Error fetching form values:', error);
        }
    }
    const updateBusinessInfo = async (info, reload = true) => {
        try {
            setLoading(true);
            const data = await api.create(`${API_ENDPOINTS.BUSINESS_INFO.UPDATE}`, info);
            setBillingAddressPopup(false)
            setLoading(false);
            if (reload === true) {
                dispatch(businessInfo());
            }
            if (info?.location) {
                setUpdatedLocationData(info?.location)
                setPopupLocationData(info?.location)
            }

        } catch (err) {
            setLoading(false);
            console.log('business info updation error occured ')
        }
    }
    const cropperError = (errorMessage) => {
        setImageCropperError(errorMessage)
    }
    useEffect(() => {
    }, [actionButtonDisable])

    useEffect(() => {
        if (adminVerificationStatus) {
            setStatus(adminVerificationStatus)
        }
    }, [adminVerificationStatus])
    const businessInfoUpdate = (event) => {
        const { name, value } = event.target;
        setBusinessInfoData((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const businessInfoModify = (event, name) => {
        const { value } = event.target;
        const errors = BusinessInfo.getFieldsError();

        if (businessInfoApiResponseData?.[name] !== value) {
            const formatRemoval = ['instagram', 'facebook', 'website', 'location', 'GSTIN', 'PAN'];

            if (formatRemoval.includes(name)) {
                setBusinessInfoData((prev) => {
                    const isAnyFieldEmpty = Object.values(prev).some(
                        (field) => field === null || field === undefined || field === ''
                    );

                    if (isAnyFieldEmpty) {
                        console.warn('Cannot update: Some fields in the previous data are empty.');
                        return prev;
                    }

                    return {
                        ...prev,
                        [name]: value,
                    };
                });
            }
            else {
                switch (name) {
                    case 'business_name':
                        setFieldLengths((prev) => ({
                            ...prev,
                            businessName: value?.length
                        }));
                        break;
                    case 'business_description':
                        setFieldLengths((prev) => ({
                            ...prev,
                            businessDescription: value?.length
                        }));
                        break;
                    case 'business_address':
                        setFieldLengths((prev) => ({
                            ...prev,
                            businessAddress: value?.length
                        }));
                        break;
                    case 'contact_name':
                        setFieldLengths((prev) => ({
                            ...prev,
                            contactPerson: value?.length
                        }));
                        break;
                    default:
                        break;
                }

                setBusinessInfoData((prev) => ({
                    ...prev,
                    [name]: formatInputValue(value)
                }));
            }

            setBusinessInfoButtonDisable((prev) => ({
                ...prev, 'dataUpdateError': false
            }))
        }
        else {
            setBusinessInfoButtonDisable((prev) => ({
                ...prev, 'dataUpdateError': true
            }))
        }

    };
    const checkErrors = (changed, all) => {
        const errors = BusinessInfo.getFieldsError();
        const hasErrors = errors.some(error => error.errors.length > 0);
        setBusinessInfoButtonDisable(prev => ({
            ...prev, 'formError': hasErrors
        }))
    }


    useEffect(() => {
        if (businessInfoData?.location) {
            setPopupLocationData(businessInfoData?.location)
        }
    }, [businessInfoData])

    useEffect(() => {
        if (businessInfoData) {
            BusinessInfo.setFieldsValue({
                business_name: businessInfoData.business_name,
                business_category: businessInfoData.business_category,
                business_description: businessInfoData.old_business_description ? businessInfoData.old_business_description : businessInfoData.business_description,
                business_address: businessInfoData.business_address,
                billing_address: businessInfoDetails?.billing_address?.address,
                contact_name: businessInfoData.contact_name,
                contact_number: businessInfoData.contact_number,
                instagram: businessInfoData.instagram,
                facebook: businessInfoData.facebook,
                whatsapp: businessInfoData.whatsapp,
                website: businessInfoData.website,
                location: businessInfoData.location,
                gst_in: businessInfoData.gst_in,
                pan_no: businessInfoData.pan_no,
                state: businessInfoData.state || 'Kerala',
                pincode: businessInfoData.pincode
            });
            if (businessInfoData?.business_name) {
                setFieldLengths((prev) => ({
                    ...prev,
                    businessName: businessInfoData?.business_name?.length
                }));
            }
            if (businessInfoData?.business_description) {
                setFieldLengths((prev) => ({
                    ...prev,
                    businessDescription: businessInfoData?.business_description?.length
                }));
            }
            if (businessInfoData?.business_address) {
                setFieldLengths((prev) => ({
                    ...prev,
                    businessAddress: businessInfoData?.business_address?.length
                }));
            }
            if (businessInfoData?.contact_name) {
                setFieldLengths((prev) => ({
                    ...prev,
                    contactPerson: businessInfoData?.contact_name?.length
                }));
            }
            if (businessInfoData?.location) {
                setUpdatedLocationData(businessInfoData?.location)
            }
        }
    }, [businessInfoData]);

    const validateGSTIN = (_, value) => {
        if (!value) {
            // Allow empty GSTIN if not required
            return Promise.resolve();
        }

        const trimmedValue = value.trim(); // Trim whitespace from input
        const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

        if (!gstinRegex.test(trimmedValue)) {
            return Promise.reject(new Error('Invalid GSTIN! Format: 22AAAAA0000A1Z5'));
        }

        return Promise.resolve(); // Validation passed
    };


    const validatePAN = (_, value) => {
        if (!value) {
            // Allow empty PAN if not required
            return Promise.resolve();
        }

        const trimmedValue = value.trim(); // Trim whitespace from input
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

        if (!panRegex.test(trimmedValue)) {
            return Promise.reject(new Error('Invalid PAN! Format: ABCDE1234F'));
        }

        return Promise.resolve(); // Validation passed
    };


    const billingAddressModalStatus = (data) => {
        if (data) {
            setBillingAddressModal(false)
        }
    }
    const handleBillingAddressModalCancel = () => {
        // setBillingAddressModal(false);
        setBillingAddressModalReset(true);
    }


    useEffect(() => {
        console.log('logoUrl', logoUrl);

        if (logoUrl) {
            setBusinessInfoData((prev) => ({
                ...prev, 'file': logoUrl
            }))
        }
    }, [logoUrl])


    useEffect(() => {
        if (billingAddressModalReset) {
            setTimeout(() => {
                setBillingAddressModalReset(false)
            }, [1000])
        }
    }, [billingAddressModalReset])

    // useEffect(()=>{
    //     if(businessInfoData){
    //         switch (name) {
    //             case 'business_name':
    //                 setFieldLengths((prev) => ({
    //                     ...prev,
    //                     businessName: business_name?.length
    //                 }));
    //                 break;
    //             case 'business_description':
    //                 setFieldLengths((prev) => ({
    //                     ...prev,
    //                     businessDescription: business_description?.length
    //                 }));
    //                 break;
    //             case 'business_address':
    //                 setFieldLengths((prev) => ({
    //                     ...prev,
    //                     businessAddress: business_address?.length
    //                 }));
    //                 break;
    //             default:
    //                 break;
    //         }
    //     }
    // },[businessInfoData])
    useEffect(() => {

        setSubmitButtonPositionTop(submitButtonRef.current.getBoundingClientRect().top)
        const handleScroll = () => {

            setScrollTop(window.scrollY)


            // if (!elementRef.current || !targetRef.current) return;

            // const elementRect = elementRef.current.getBoundingClientRect();
            // const targetRect = targetRef.current.getBoundingClientRect();

            // // Check if the top side of the element hits the target
            // if (
            //     elementRect.top <= targetRect.bottom &&
            //     elementRect.bottom >= targetRect.top
            // ) {
            //     setIsIntersecting(true);
            // } else {
            //     setIsIntersecting(false);
            // }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (!submitButtonRef.current || !formHolderRef.current) return;

        const submitButton = submitButtonRef.current;
        const formHolder = formHolderRef.current;

        const submitButtonHeight = submitButton.offsetHeight;
        const isFixed = scrollTop > submitButtonPositionTop && scrollTop > 0;

        setSubmitBtnFixed(isFixed); // Update the state

        // formHolder.style.paddingTop = isFixed ? `${submitButtonHeight}px` : '0';
    }, [scrollTop, submitButtonPositionTop]);

    useEffect(() => {
        console.log('billing_address?.address', billing_address)
    }, [billing_address])

    const onFinishFailed = ({ errorFields }) => {
        console.log('Validation Failed:', errorFields);
        // Focus the first invalid input (optional)
        form.scrollToField(errorFields[0].name, {
            behavior: 'smooth',
        });
    };


    useEffect(() => {
        if (businessInfoDetails.old_business_description) {
            console.log('empty')
        }
        // if (!businessInfoDetails.old_business_description || businessInfoDetails.old_business_description.trim() === "") {
        //     console.log("old_business_description is empty");
        // } else {
        //     console.log("old_business_description is not empty");
        // }
    }, [businessInfoDetails])

    useEffect(()=>{
        console.log('businessInfoButtonDisable' , businessInfoButtonDisable)
    },[businessInfoButtonDisable])

    return (
        <>
            {
                loading && (
                    <div className="spinner sm center">
                        <Spin />
                    </div>
                )
            }
            <Card >
                <div className="business_information_form form_wrap "  >
                    <Warning />

                    <Form
                        style={{ paddingTop: '1em' }}
                        form={BusinessInfo}
                        className='form_body'
                        onFinish={onFinish}
                        onFieldsChange={checkErrors}
                        validateMessages={validateMessages}
                        noFinishFailed={onFinishFailed}
                    >

                        <div ref={formHolderRef} className='demo_holder'>
                            {
                                submitBtnFixed && (
                                    <div className="business_info_upload_btn fixed" >
                                        <Form.Item className='text-right' >
                                            <Button type='primary' htmlType="submit" disabled={businessInfoButtonDisable.formError} >Save</Button>
                                        </Form.Item>
                                    </div>
                                )
                            }
                            <div className={`business_info_upload_btn ${submitBtnFixed && 'hidden'}`} ref={submitButtonRef}>
                                <Form.Item className='text-right' >
                                    <Button type='primary' htmlType="submit" disabled={businessInfoButtonDisable.formError} >Save</Button>
                                </Form.Item>
                            </div>
                            <Row gutter={[36, 0]} className='form_top'>
                                <Col className="left sm_icon">
                                    <div className="logo_upload text-center bg_white">
                                        {
                                            !previewRemove && (
                                                !logoUrl ? (
                                                    <Avatar className="fill">
                                                        {businessInfoData?.business_name?.[0]}
                                                    </Avatar>
                                                    // <span style={{ display: logoUrl ? 'block' : 'none', width: '100%', height: '100%' }}>
                                                    //     <div className='poster_shimmer_wrap h_auto' style={{ width: '100%', height: '100%' }}>
                                                    //         <ShimmerCategoryItem
                                                    //             imageType="rectangular"
                                                    //             imageWidth="100%"
                                                    //             imageHeight="100%"
                                                    //             text={false}
                                                    //         />
                                                    //     </div>
                                                    // </span>
                                                ) : (
                                                    <span style={{ display: logoUrl ? 'block' : 'none', width: '100%', height: '100%' }}>
                                                        <img
                                                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                            src={logoUrl}
                                                            alt="Logo Icon"
                                                        />
                                                    </span>
                                                )
                                            )
                                        }


                                        <ImageCropper dataHandle={data} imageCropperError={cropperError} defaultHoverIcon="change" />
                                        {logoError && <Alert className="cropper_error" message="Poster is required." type="error" style={{ marginTop: '10px' }} />}
                                    </div>
                                </Col>
                                <span className="custom_error sm_block">
                                    {imageCropperError}
                                </span>
                                <Col className="right">
                                    <div className={`input_holder `}>
                                        <div className="description_wrap">
                                            <label htmlFor="business_name" className='text_red d-block input_label'>Business Name</label>
                                            <Form.Item
                                                name="business_name"
                                                onChange={(event) => businessInfoModify(event, 'business_name')}
                                                rules={[{ required: true, message: content?.EnterBusinessName }]}
                                            >
                                                <Input
                                                    className="input_field"
                                                    placeholder={placeHolderContent?.BusinessName}
                                                    type="text"
                                                    maxLength={limit.business_name}
                                                />
                                            </Form.Item>
                                            {/* <div className="">
                                                <span class={` form_note ${fieldLengths?.businessName === limit?.business_name && 'limit'}`} ><span>{fieldLengths?.businessName}</span>/{limit?.business_name}</span>
                                            </div> */}
                                            <InputFieldMxLength maxValue={limit?.business_name} valueLength={fieldLengths?.businessName} />
                                        </div>
                                    </div>
                                    <div className=' input_holder'>
                                        <label htmlFor="business_category" className='text_red d-block input_label'>Business Category</label>
                                        <Form.Item
                                            name="business_category"
                                            onChange={(event) => businessInfoModify(event, 'business_category')}
                                            rules={[{ message: 'Please enter the business category' }]}
                                        >
                                            <Input
                                                placeholder="Photography"
                                                className='input_field'
                                                type="text"
                                                disabled={true}
                                            />
                                        </Form.Item>
                                    </div>
                                </Col>
                                <span className="custom_error sm_none">
                                    {imageCropperError}
                                </span>
                            </Row>
                            <div style={{ width: "100%" }} className={`input_holder ${!fieldStatus?.business_description && 'warning_status_active'}`}>
                                <div className="description_wrap">
                                    <label htmlFor="business_description" className='text_red d-block input_label'>Business Description</label>
                                    <Form.Item
                                        name="business_description"
                                        onChange={(event) => businessInfoModify(event, 'business_description')}
                                        rules={[{ message: "Enter your Business Description." }]}
                                    >
                                        <TextArea
                                            maxLength={limit.business_description}
                                            style={{ margin: "10px 0" }}
                                            rows={5}
                                            className='input_field'
                                            placeholder={placeHolderContent?.BusinessDescription}
                                        />
                                    </Form.Item>
                                    <InputFieldMxLength maxValue={limit?.business_description} valueLength={fieldLengths?.businessDescription} />

                                </div>
                            </div>
                            <div className='input_holder'>
                                <div className="description_wrap">
                                    <label htmlFor="business_address" className='text_red d-block input_label'>Business Address</label>
                                    <Form.Item
                                        name="business_address"
                                        rules={[{ message: content?.EnterBusinessAddress }]}
                                        onChange={(event) => businessInfoModify(event, 'business_address')}
                                    >
                                        <TextArea
                                            style={{ margin: "10px 0" }}
                                            rows={5}
                                            maxLength={limit.business_address}
                                            // placeholder={placeHolderContent?.BusinessAddress}
                                            className='input_field'
                                            disabled={true}
                                        />
                                    </Form.Item>
                                    {/* <InputFieldMxLength maxValue={limit?.business_address} valueLength={fieldLengths?.businessAddress} /> */}

                                    {/* <div className="">
                                        <span class={` form_note ${fieldLengths?.businessAddress === limit?.business_address && 'limit'}`} ><span>{fieldLengths?.businessAddress}</span>/{limit?.business_address}</span>
                                    </div> */}
                                </div>

                            </div>
                            <div className='input_holder billing_address_wrap'>
                                <label htmlFor="billing_address" className='text_red d-block input_label'>Billing Address</label>
                                <Form.Item
                                    name="billing_address"
                                    rules={[{ message: content?.EnterBusinessAddress }]}
                                    onChange={(event) => businessInfoModify(event, 'billing_address')}
                                >
                                    <TextArea
                                        style={{ margin: "10px 0" }}
                                        rows={5}
                                        disabled={true}
                                        // disabled={billing_address?.address !== undefined}
                                        // placeholder={placeHolderContent?.BusinessAddress}
                                        className='input_field'
                                        maxLength={200}
                                    />
                                </Form.Item>
                                <div className="text-right">
                                    <Button type='primary' className='sm' onClick={() => {

                                        setBillingAddressModal(true)
                                        setBillingAddressModalReset(false);

                                    }}> Manage Address</Button>
                                </div>
                            </div>
                            <div className="contact_block">
                                <div className={`input_holder ${!fieldStatus?.contact_name && 'warning_status_active'}`}>
                                    <label htmlFor="contact_name" className='text_red d-block input_label'>Contact Person</label>
                                    <Form.Item
                                        name="contact_name"
                                        rules={[{ message: content?.EnterContactPersonName }]}
                                        onChange={(event) => businessInfoModify(event, 'contact_name')}
                                    >
                                        <Input
                                            className='input_field'
                                            placeholder={placeHolderContent?.ContactPerson}
                                            type="text"
                                            maxLength={150}
                                            minLength={2}
                                        />
                                    </Form.Item>
                                    <InputFieldMxLength maxValue={limit?.contact_person} valueLength={fieldLengths?.contactPerson} />
                                </div>
                                <div className={`input_holder ${!fieldStatus?.contact_name && 'warning_status_active'}`}>
                                    <label htmlFor="gst_in" className='text_red d-block input_label'>GSTIN</label>
                                    <Form.Item
                                        name="gst_in"
                                        validateFirst={true}
                                        rules={[
                                            {
                                                message: content?.InvalidGST,
                                            },
                                            {
                                                validator: validateGSTIN
                                            }
                                        ]}
                                        onChange={(event) => businessInfoModify(event, 'gst_in')}
                                    >
                                        <Input
                                            className='input_field'
                                            placeholder={placeHolderContent?.GSTIN}
                                            type="text"
                                            maxLength={15}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                            }}
                                        />
                                    </Form.Item>
                                </div>
                                <div className='input_holder'>
                                    <label htmlFor="contact_number" className='text_red d-block input_label'>Contact Number</label>
                                    <div className="country_code_wrap">
                                        <span className='country_code'>+91</span>
                                        <Form.Item
                                            name="contact_number"
                                            rules={[
                                                { message: 'Enter contact number.' },
                                                { pattern: /^\d{10}$/, message: 'Please enter a valid 10-digit mobile number' }
                                            ]}
                                            onChange={(event) => businessInfoModify(event, 'contact_number')}
                                        >
                                            <Input
                                                disabled={true}
                                                className='input_field'
                                                placeholder="Enter Contact Number."
                                                type="text"
                                                maxLength={10}
                                                onKeyDown={(e) => {
                                                    if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                                                        e.preventDefault();
                                                    }
                                                }}

                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className={`input_holder ${!fieldStatus?.contact_name && 'warning_status_active'}`}>
                                    <label htmlFor="pan_no" className='text_red d-block input_label'>PAN</label>
                                    <Form.Item
                                        name="pan_no"
                                        rules={[
                                            {
                                                message: content?.InvalidGST,
                                            },
                                            {
                                                validator: validatePAN
                                            }
                                        ]}
                                        onChange={(event) => businessInfoModify(event, 'pan_no')}
                                    >
                                        <Input
                                            className='input_field'
                                            placeholder={placeHolderContent?.PAN}
                                            type="text"
                                            maxLength={10}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                            }}
                                        />
                                    </Form.Item>
                                </div>
                                <div className={`input_holder ${!fieldStatus?.contact_name && 'warning_status_active'}`}>
                                    <label htmlFor="state" className='text_red d-block input_label'>State</label>
                                    <Form.Item
                                        name="state"
                                        rules={[
                                            // {
                                            //     message: content?.InvalidGST,
                                            // },

                                        ]}
                                        onChange={(event) => businessInfoModify(event, 'pan_no')}
                                    >
                                        <Input
                                            className='input_field'
                                            placeholder={placeHolderContent?.PAN}
                                            type="text"
                                            maxLength={10}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                            }}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </div>
                                <div className={`input_holder ${!fieldStatus?.contact_name && 'warning_status_active'}`}>
                                    <label htmlFor="pincode" className='text_red d-block input_label'>Pin Code</label>
                                    <Form.Item
                                        name="pincode"
                                        rules={[
                                            {
                                                message: content?.InvalidGST,
                                            },

                                        ]}
                                        onChange={(event) => businessInfoModify(event, 'pan_no')}
                                    >
                                        <Input
                                            className='input_field'
                                            type="text"
                                            maxLength={10}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                            }}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='input_holder'>
                                <label htmlFor="instagram" className='text_red d-block input_label'>Instagram</label>
                                <Form.Item
                                    name="instagram"
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                if (!value || value === '') {
                                                    return Promise.resolve(); // Allow empty since the field is non-mandatory
                                                }
                                                if (!/^https:\/\/www\.instagram\.com\/[A-Za-z0-9._]+\/?$/.test(value)) {
                                                    return Promise.reject(new Error('Please enter a valid Instagram page URL'));
                                                }
                                                return Promise.resolve();
                                            }
                                        }
                                    ]}
                                    onChange={(event) => businessInfoModify(event, 'instagram')}
                                >
                                    <Input
                                        placeholder={placeHolderContent?.Instagram}
                                        type="text"
                                        className='input_field text_transform_normal'
                                    />
                                </Form.Item>
                            </div>
                            <div className='input_holder'>
                                <label htmlFor="facebook" className='text_red d-block input_label'>Facebook</label>
                                <Form.Item
                                    name="facebook"
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                if (!value || value === '') {
                                                    return Promise.resolve(); // Allow empty since the field is non-mandatory
                                                }
                                                if (!/^https:\/\/www\.facebook\.com\/[A-Za-z0-9._%+-]+\/?$/.test(value)) {
                                                    return Promise.reject(new Error('Please enter a valid Facebook page URL'));
                                                }
                                                return Promise.resolve();
                                            }
                                        }
                                    ]}
                                    onChange={(event) => businessInfoModify(event, 'facebook')}
                                >
                                    <Input
                                        className='input_field text_transform_normal'
                                        placeholder={placeHolderContent?.Facebook}
                                        type="url"
                                    />
                                </Form.Item>
                            </div>
                            <div className='input_holder'>
                                <label htmlFor="whatsapp" className='text_red d-block input_label'>WhatsApp</label>
                                <div className="country_code_wrap">
                                    <span className="country_code">+91</span>
                                    <Form.Item
                                        name="whatsapp"
                                        rules={[{ pattern: /^\d{10}$/, message: 'Please enter a valid 10-digit phone number' }]}
                                        onChange={(event) => businessInfoModify(event, 'whatsapp')}
                                    >
                                        <Input
                                            disabled={true}
                                            placeholder="e.g.: 9995657689"
                                            className='input_field text_transform_normal'
                                            type="text"
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='input_holder'>
                                <label htmlFor="website" className='text_red d-block input_label'>Website</label>
                                <Form.Item
                                    name="website"
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                if (!value || value === '') {
                                                    return Promise.resolve(); // Allow empty since the field is non-mandatory
                                                }
                                                // Ensure only HTTPS URLs are allowed
                                                if (!/^https:\/\/[^\s$.?#].[^\s]*$/.test(value)) {
                                                    return Promise.reject(new Error('Please enter a valid HTTPS URL'));
                                                }
                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                    onChange={(event) => businessInfoModify(event, 'website')}
                                >
                                    <Input
                                        className='input_field text_transform_normal'
                                        placeholder={placeHolderContent?.Website}
                                        type="url" />
                                </Form.Item>
                            </div>
                            <div className='input_holder business_location_wrap'>
                                <label htmlFor="location" className='text_red d-block input_label'>Direction</label>
                                <Form.Item

                                >
                                    <Input
                                        disabled="true"
                                        name="location"
                                        placeholder={placeHolderContent?.BusinessLocation}
                                        className='input_field text_transform_normal'
                                        type="url"
                                        value={updatedLocationData}
                                    />
                                    <Button type='primary' onClick={() => {
                                        setActionModal((prev) => ({
                                            ...prev,
                                            direction: true // Update the direction pro perty
                                        }));
                                    }}>
                                        {businessInfoData?.location ? 'Edit' : 'Add'}
                                    </Button>
                                </Form.Item>
                            </div>
                        </div>
                    </Form>
                </div >
                {
                    //      <NoResults
                    //      type={'business_info'}
                    //      title={'Account Verification Pending'}
                    //      description={'Your Account is awaiting verification from our Admin. We will update you once the review is finished and your account is active.'}>
                    //  </NoResults>
                }

                <Modal
                    className='sm_modal work_modal center_modal text-center'
                    afterClose={() => (document.body.style.overflow = 'initial')}
                    open={successModal}
                    onOk={handleCancelFn}
                    onCancel={handleCancelFn}
                    footer={[
                        <div className='text-center'>
                            <Button key="ok" type="primary" className="short wide " onClick={handleCancelFn}>
                                Ok
                            </Button>
                        </div>
                    ]}
                >
                    <div className="modal_cnt">
                        <h2 className='text_lg text_red'>{popupContent?.content?.title}</h2>
                        <p className="md">{popupContent?.content?.description}</p>
                    </div>
                </Modal>

            </Card >

            <Modal
                className='sm_modal  location_modal wide_modal text-center center_modal'
                afterClose={() => (document.body.style.overflow = 'initial')}
                open={actionModal.direction}
                footer={<Button key="close" type="text" className="short custom_btn" onClick={handleActionModalCancel}>
                    Close
                </Button>}
                onCancel={handleActionModalCancel}
            >
                <div className="wrap">
                    <div className="text-center title_wrap">
                        <h2 className="text_red mb text_md">{actionModalData?.direction?.title}</h2>
                        <div className="content_wrap" style={{ textAlign: 'left' }}>
                            {actionModalData?.direction?.content}
                        </div>
                    </div>

                    {/* action modal */}
                    <Form
                        form={form}

                    >
                        <Form.Item
                            className='custom_error'
                        >
                            <div className="input_holder location_input_holder">
                                <label className='input_label text_capitalize text_red d-block'>
                                    {actionModalData?.direction?.label}
                                </label>
                                <Input
                                    name='location'
                                    maxLength={actionModalData?.direction?.maxLength}
                                    onChange={(event) => {
                                        setPopupLocationData(event.target.value);
                                        validateGoogleMapsUrl(event) // Manually trigger validation
                                    }}
                                    className='input_field text_transform_normal'
                                    placeholder={actionModalData?.direction?.placeholder}
                                    value={popupLocationData}
                                />
                            </div>
                        </Form.Item>

                        <div className="button_wrap">
                            <div className="text-center">
                                <Button
                                    type="primary"
                                    disabled={actionButtonDisable?.direction}
                                    onClick={() => {
                                        modalContinue('location')
                                    }}
                                >
                                    Continue
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal>
            <Modal
                className='sm_modal  billing_address_modal medium_modal text-center center_modal'
                afterClose={() => (document.body.style.overflow = 'initial')}
                open={billingAddressModal}
                onCancel={handleBillingAddressModalCancel}
                footer={<Button key="close" type="text" className="short custom_btn md" onClick={handleBillingAddressModalCancel}>
                    Close
                </Button>}
            >
                <BillingAddress btnStatus={true} uploadStatus={billingAddressModalStatus} modalData={billingAddressModal} resetFlag={billingAddressModalReset} modalWorking={(data) => {
                    setBillingAddressModal(data)
                }} />
            </Modal>



        </>
    );
};

export default BusinessInfo;